import React from 'react'
import { Typography, Icon, Row, Col, Collapse } from 'antd';
import { withApollo } from 'react-apollo'
import { Queries } from '../../../graphql'
import Container from '../../../components/user/Container'
import banner from '../../../assets/images/abouts/banner.png'
import imgYoutube from '../../../assets/images/abouts/img-youtube.png'
import imgIcons1 from '../../../assets/images/abouts/icons-01.png'
import imgIcons2 from '../../../assets/images/abouts/icons-02.png'
import imgIcons3 from '../../../assets/images/abouts/icons-03.png'
import imgIcons4 from '../../../assets/images/abouts/icons-04.png'
//////////////////////addmodalINTERNAL_SERVER_ERROR
import ModalErrors from '../../../components/user/ModalErrors'
import { convertToHTMl } from '../../../utils/markDown'
import { youtubeParser } from '../../../utils/youtube'

const { Text, Title } = Typography

const { Panel } = Collapse;

const arrayDetail1 = [
    'สํานักงานบริหาร',
    'สํานักงานกลาง',
    'โรงพยาบาลจุฬาลงกรณ์',
    'โรงพยาบาลสมเด็จพระบรมราชเทวี ณ ศรีราชา',
    'สถานเสาวภา',
    'สํานักงานบรรเทาทุกข์และประชานามัยพิทักษ์',
    'สํานักงานยุวกาชาด',
    'สํานักงานอาสากาชาด',
    'ศูนย์บริการโลหิตแห่งชาติ',
    'สํานักงานจัดหารายได้',
    'สถาบันการพยาบาลศรีสวรินทิรา สภากาชาดไทย',
    'สํานักงานบริหารทรัพยากรบุคคล',
    'สํานักงานบริหารกิจการเหล่ากาชาด',
]

const arrayDetail2 = [
    'ศูนย์เวชศาสตร์ฟื้นฟู',
    'ศูนย์ดวงตาสภากาชาดไทย',
    'ศูนย์วิจัยโรคเอดส์',
    'ศูนย์รับบริจาคอวัยวะสภากาชาดไทย',
    'ศูนย์เทคโนโลยีสารสนเทศ',
    'ศูนย์ฝึกอบรมปฐมพยาบาลและสุขภาพอนามัย',
]

class Abouts extends React.Component {
    state = {
        showModalErrors: false,
        dataFetch:null
    }

    fetchListPost = async () => {
        const { client } = this.props
        const { data, errors } = await client.query({
            query: Queries.fetchListPost,
            variables: {
                type: "ABOUTUS"
            }
        })
        //////////////////////addmodalINTERNAL_SERVER_ERROR
        if (errors && errors[0].extensions.code === 'INTERNAL_SERVER_ERROR') {
            await this.setState({
                showModalErrors: true
            })
        }

        await this.setState({
            dataFetch: data.fetchListPost.data[0]
        })
    }

    componentDidMount = async () => {
        await this.fetchListPost()
    }

    render() {
        const { match } = this.props
        const { dataFetch } = this.state
        return (
            <Container match={match}>
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                {
                    this.state.showModalErrors &&
                    <ModalErrors />
                }
                {/* //////////////////////addmodalINTERNAL_SERVER_ERROR */}
                <div id="page-abouts">
                    {
                        dataFetch &&
                        <Row gutter={20}>
                            <Col>
                                <div className="uiMediahead">
                                    <i className="uiMediaThumbImg" style={{ backgroundImage: "url(" + banner + ")", }}></i>
                                </div>
                                <div className="mt-4">
                                    <div className="mb-5 white-space">
                                        <Title level={4}>
                                            { dataFetch.postTitleTH ? <div dangerouslySetInnerHTML={{ __html: convertToHTMl(dataFetch.postTitleTH) }}/> : '' }
                                        </Title>
                                        { dataFetch.descriptionTH }
                                    </div>

                                    <Row gutter={20} className="mb-5">
                                        <Col span={18} offset={3} >
                                            <iframe src={"https://www.youtube.com/embed/"+youtubeParser(dataFetch.linkOriginal)} style={{ width: '100%', height: '450px' }}></iframe>
                                        </Col>
                                    </Row>

                                    <Row gutter={24} type="flex" className="my-5" justify="center">
                                        <Col xs={24} md={5} align="center">
                                            <img src={imgIcons1} style={{ maxWidth: "70%" }} className="mb-2" /><br />
                                            <strong className="color-black">
                                                สภาอุณาโลมแดง
                                            </strong>
                                            <Title level={3} className="color-orange">
                                                2436 (ร.ศ.112)
                                            </Title>
                                            <Text>
                                                สภากาชาดไทย เป็นองค์กรการกุศลเพื่อ
                                                มนุษยธรรมถือกําเนิดขึ้น
                                            </Text>
                                        </Col>
                                        <Col xs={24} md={5} align="center">
                                            <img src={imgIcons2} style={{ maxWidth: "70%" }} className="mb-2" /><br />
                                            <strong className="color-black">
                                                สภากาชาดสยาม
                                            </strong>
                                            <Title level={3} className="color-orange">
                                                2449
                                            </Title>
                                            <Text>
                                                เปลี่ยนชื่อจากสภาอุณาโลมแดงเป็น
                                                “สภากาชาดสยาม”
                                            </Text>
                                        </Col>
                                        <Col xs={24} md={5} align="center">
                                            <img src={imgIcons3} style={{ maxWidth: "70%" }} className="mb-2" /><br />
                                            <strong className="color-black">
                                                สภากาชาไทย
                                            </strong>
                                            <Title level={3} className="color-orange">
                                                2482
                                            </Title>
                                            <Text>
                                                เปลี่ยนชื่อจากสภากาชาดสยามเป็น
                                                “สภากาชาดไทย” ตามชื่อประเทศ มาจนบัดนี้
                                            </Text>
                                        </Col>
                                        <Col xs={24} md={5} align="center">
                                            <img src={imgIcons4} style={{ maxWidth: "70%" }} className="mb-2" /><br />
                                            <strong className="color-black">
                                                สภากาชาไทย
                                            </strong>
                                            <Title level={3} className="color-orange">
                                                2546
                                            </Title>
                                            <Text>
                                                กรรมการบริหารสภากาชาดไทยได้มีมติให้ใช้
                                                เครื่องหมายสภากาชาดไทยที่ใช้ในปัจจุบัน
                                            </Text>
                                        </Col>
                                    </Row>
                                    <hr></hr>
                                </div>
                            </Col>
                        </Row>
                    }
                    
                </div>
            </Container>
        )
    }
}

Abouts.propTypes = {
    //
}

export default withApollo(Abouts)